import { render } from "./AdminTableManagement.vue?vue&type=template&id=8f270412&scoped=true"
import script from "./AdminTableManagement.vue?vue&type=script&lang=js"
export * from "./AdminTableManagement.vue?vue&type=script&lang=js"

import "./AdminTableManagement.vue?vue&type=style&index=0&id=8f270412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f270412"]])

export default __exports__